import { autoinject } from 'aurelia-framework';

@autoinject
export class DeviceAdminCard {
 
  constructor() {
   
  }

  bind(bindingContext: any, overrideContext: any) {
   
  }

  attached() {
    
  }

  detached() {
   
  }

}